document.addEventListener('DOMContentLoaded', function () {

    // Scope to the mobile container
    const container = document.querySelector('.ict-m-pdp-container');
    if (!container) return; // Exit if not found (e.g. disabled)

    // 1. Helpers & State
    const formatMoney = (cents) => {
        return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    };

    const normalize = (str) => str ? str.toString().toLowerCase().trim() : '';

    const variantData = window.productVariantsMobile || [];
    const productOptions = window.productOptionsMobile || []; // e.g. ["Color", "Size"]

    const priceContainer = container.querySelector('.ict-m-price-container .ict-m-price');
    const addBtnText = container.querySelector('.ict-m-add-btn span:first-child');
    const addBtn = container.querySelector('.ict-m-add-btn');

    // State is now generic: holds value for each option index
    let state = {
        options: new Array(productOptions.length).fill(null)
    };

    // Determine which index is the "Visual" one (for image filtering)
    let visualOptionIndex = -1;
    productOptions.forEach((name, idx) => {
        const n = normalize(name);
        if (n.includes('color') || n.includes('colour') || n.includes('pattern') || n.includes('style') || n.includes('design') || n.includes('material')) {
            if (visualOptionIndex === -1) visualOptionIndex = idx; // Pick first match
        }
    });
    // Fallback
    if (visualOptionIndex === -1 && productOptions.length > 0) {
        visualOptionIndex = 0;
    }

    console.log("Mobile Visual Option Index detected:", visualOptionIndex, productOptions[visualOptionIndex]);


    // 2. Core Logic

    // --- Variant Matching ---
    const updateVariant = () => {
        const matchedVariant = variantData.find(v => {
            return v.options.every((val, idx) => {
                const selected = state.options[idx];
                if (!selected) return false;
                return normalize(val) === normalize(selected);
            });
        });

        if (matchedVariant) {
            // Update Price
            if (priceContainer) priceContainer.innerText = formatMoney(matchedVariant.price);

            // Update Button
            if (matchedVariant.available) {
                if (addBtnText) addBtnText.innerText = 'ADD TO CART';
                if (addBtn) {
                    addBtn.disabled = false;
                    addBtn.removeAttribute('data-action'); // Remove special handling
                }
            } else {
                if (addBtnText) addBtnText.innerText = 'SOLD OUT';
                if (addBtn) {
                    addBtn.disabled = true;
                    addBtn.removeAttribute('data-action');
                }
            }

            // Update ID
            const idInput = container.querySelector('input[name="id"]');
            if (idInput) idInput.value = matchedVariant.id;

        } else {
            const allSelected = state.options.every(o => o !== null);
            if (allSelected) {
                if (addBtnText) addBtnText.innerText = 'UNAVAILABLE';
                if (addBtn) {
                    addBtn.disabled = true;
                    addBtn.removeAttribute('data-action');
                }
            } else {
                // Check if we have at least one option selected and only one option type
                const optionsWithUI = [];
                productOptions.forEach((_, idx) => {
                    const wrapper = container.querySelector(`[data-option-index="${idx}"]`);
                    // Also check for hidden inputs (for default title options)
                    const hiddenInput = container.querySelector(`input[data-option-index="${idx}"]`);
                    if (wrapper) {
                        optionsWithUI.push(idx);
                    } else if (hiddenInput) {
                        // Hidden option - still need to track it but don't require user selection
                        // Set state from hidden input value
                        if (hiddenInput.value && !state.options[idx]) {
                            state.options[idx] = hiddenInput.value;
                        }
                    }
                });

                // If no options have UI (single variant product or only hidden options), just match the first variant
                if (optionsWithUI.length === 0 && variantData.length > 0) {
                    const firstVariant = variantData[0];
                    if (priceContainer) priceContainer.innerText = formatMoney(firstVariant.price);
                    if (firstVariant.available) {
                        if (addBtnText) addBtnText.innerText = 'ADD TO CART';
                        if (addBtn) {
                            addBtn.disabled = false;
                            addBtn.removeAttribute('data-action');
                        }
                    } else {
                        if (addBtnText) addBtnText.innerText = 'SOLD OUT';
                        if (addBtn) {
                            addBtn.disabled = true;
                            addBtn.removeAttribute('data-action');
                        }
                    }
                    const idInput = container.querySelector('input[name="id"]');
                    if (idInput) idInput.value = firstVariant.id;
                    return;
                }

                const hasAnySelection = optionsWithUI.some(idx => state.options[idx] !== null);

                if (hasAnySelection && optionsWithUI.length === 1) {
                    // Special case: Product with only one option type (e.g., color only, no size)
                    const selectedIdx = optionsWithUI.find(idx => state.options[idx] !== null);
                    if (selectedIdx !== undefined) {
                        const selectedValue = state.options[selectedIdx];
                        const fallbackVariant = variantData.find(v => {
                            return normalize(v.options[selectedIdx]) === normalize(selectedValue);
                        });

                        if (fallbackVariant) {
                            // Found a variant - update UI
                            if (priceContainer) priceContainer.innerText = formatMoney(fallbackVariant.price);
                            if (fallbackVariant.available) {
                                if (addBtnText) addBtnText.innerText = 'ADD TO CART';
                                if (addBtn) {
                                    addBtn.disabled = false;
                                    addBtn.removeAttribute('data-action');
                                }
                            } else {
                                if (addBtnText) addBtnText.innerText = 'SOLD OUT';
                                if (addBtn) {
                                    addBtn.disabled = true;
                                    addBtn.removeAttribute('data-action');
                                }
                            }
                            const idInput = container.querySelector('input[name="id"]');
                            if (idInput) idInput.value = fallbackVariant.id;
                            return; // Exit early
                        }
                    }
                }

                // Default: Show "SELECT OPTIONS"
                if (addBtnText) addBtnText.innerText = 'SELECT OPTIONS';
                if (addBtn) {
                    addBtn.disabled = false; // Enable button so it can be clicked
                    addBtn.setAttribute('data-action', 'select-options'); // Mark for special handling
                }
            }
        }
    };

    // --- Visual Filter & Dynamic Layout ---
    const filterAndLayout = () => {
        // FIX: Always show all images. Validate visibility first.
        // User Requirement: "Show All Product Mockup Images"
        // We disable the visual filtering that was hiding unmatched images.

        const allMedia = Array.from(container.querySelectorAll('.ict-m-media-wrapper'));
        allMedia.forEach(item => {
            item.classList.remove('ict-m-force-hide');
        });

        // Skip the rest of the filtering logic
        return;
    };


    // --- Scroll & Layout Logic (Sticky Handoff) ---
    const panel = container.querySelector('.ict-m-bottom-panel');
    const placeholder = container.querySelector('#ict-m-panel-placeholder');
    const mediaCol = container.querySelector('.ict-m-media-column');

    // Safety check
    if (!panel || !placeholder || !mediaCol) return;

    const handleLayout = () => {
        // 1. Sync Placeholder Height to Match Panel
        // This ensures that when panel is fixed, the gap is correct.
        // And when panel is docked (static), it naturally fills that space.
        const h = panel.offsetHeight;
        placeholder.style.height = h + 'px';

        // Force a check immediately to avoid jumps
        handleScroll();
    };

    const handleScroll = () => {
        // Desktop Check (Disable logic if > 989px)
        if (window.innerWidth > 989) return;

        const panelHeight = panel.offsetHeight;
        const triggerPoint = window.innerHeight - panelHeight;

        // Where does the media column end relative to current viewport?
        const mediaRect = mediaCol.getBoundingClientRect();

        // LOGIC:
        // If the bottom of the media column is HIGHER (or equal) to the top of the fixed panel...
        // ...it means we have scrolled PAST the images.
        // So we DOCK the panel.

        if (mediaRect.bottom <= triggerPoint) {
            // DOCKED STATE (Static)
            if (!panel.classList.contains('ict-m-docked')) {
                panel.classList.add('ict-m-docked');
                placeholder.style.display = 'none'; // Collapse placeholder, panel takes space
            }
        } else {
            // FIXED STATE (Bottom)
            if (panel.classList.contains('ict-m-docked')) {
                panel.classList.remove('ict-m-docked');
                placeholder.style.display = 'block'; // Expand placeholder, panel floats
            }
        }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleLayout);

    // Observer to detect height changes in panel (e.g. variant change)
    const resizeObserver = new ResizeObserver(() => {
        handleLayout();
    });
    resizeObserver.observe(panel);

    // Initial call
    setTimeout(handleLayout, 100);


    // 3. Init & Event Listeners
    const initInputs = () => {
        productOptions.forEach((_, idx) => {
            const wrapper = container.querySelector(`[data-option-index="${idx}"]`);

            // Also check for hidden inputs (for "Default Title" options)
            const hiddenInput = container.querySelector(`input[data-option-index="${idx}"]`);

            if (wrapper) {
                // Support both Radio (Colors) and Select (Size)
                let checkedInput = wrapper.querySelector('input:checked') || wrapper.querySelector('select');
                let isSelect = false;

                if (checkedInput && checkedInput.tagName === 'SELECT') {
                    isSelect = true;
                    // Ensure native select has value
                    if (!checkedInput.value && checkedInput.options.length > 0) {
                        checkedInput.selectedIndex = 0;
                    }
                } else if (!checkedInput) {
                    // Radio Fallback
                    const firstInput = wrapper.querySelector('input:not([disabled])');
                    if (firstInput) {
                        firstInput.checked = true;
                        checkedInput = firstInput;
                    }
                }

                if (checkedInput) {
                    state.options[idx] = checkedInput.value;

                    // Visual Visuals
                    if (wrapper.classList.contains('ict-m-variant-row') && !isSelect) {
                        const parent = checkedInput.closest('.ict-m-swatch-compact');
                        if (parent) parent.classList.add('selected');
                        // Also update displayed label if needed
                        const valSpan = wrapper.querySelector('.ict-m-selected-val');
                        if (valSpan) valSpan.innerText = checkedInput.value;
                    }

                    // Size Display Update
                    if (isSelect) {
                        const display = wrapper.querySelector('.ict-m-current-size');
                        if (display) display.innerText = `Size: ${checkedInput.value}`;
                    }
                }
            } else if (hiddenInput) {
                // Hidden input (e.g., "Default Title" option) - set state directly
                if (hiddenInput.value) {
                    state.options[idx] = hiddenInput.value;
                }
            }
        });

        updateVariant();
        filterAndLayout();
        handleLayout(); // Check layout after init
    };

    // Generic Event Delegation scoped to container
    container.addEventListener('change', (e) => {
        // Handle Radios
        if (e.target.matches('input[type="radio"]')) {
            const wrapper = e.target.closest('[data-option-index]');
            if (wrapper) {
                const idx = parseInt(wrapper.dataset.optionIndex);
                if (!isNaN(idx)) {
                    state.options[idx] = e.target.value;

                    if (wrapper.querySelector('.ict-m-swatch-list-compact')) {
                        wrapper.querySelectorAll('.ict-m-swatch-compact').forEach(el => el.classList.remove('selected'));
                        const parent = e.target.closest('.ict-m-swatch-compact');
                        if (parent) parent.classList.add('selected');

                        const valSpan = wrapper.querySelector('.ict-m-selected-val');
                        if (valSpan) valSpan.innerText = e.target.value;
                    }

                    updateVariant();
                    if (idx === visualOptionIndex) {
                        filterAndLayout();
                        setTimeout(handleLayout, 50); // Reflow check
                    }
                }
            }
        }

        // Handle Selects
        if (e.target.matches('select')) {
            const wrapper = e.target.closest('[data-option-index]');
            if (wrapper) {
                const idx = parseInt(wrapper.dataset.optionIndex);
                if (!isNaN(idx)) {
                    state.options[idx] = e.target.value;

                    const display = wrapper.querySelector('.ict-m-current-size');
                    if (display) display.innerText = `Size: ${e.target.value}`;

                    updateVariant();
                    if (idx === visualOptionIndex) {
                        filterAndLayout();
                        setTimeout(handleLayout, 50);
                    }
                }
            }
        }
    });

    // Dropdown Toggles (Size/Modals) - SCOPED IDS
    // Dropdown Toggles (Size/Modals) - SCOPED IDS
    function toggleModal(id, show) {
        const m = document.getElementById(id);
        if (m) {
            if (show) {
                m.classList.add('active');
                document.body.style.overflow = 'hidden'; // Lock Body Scroll
            } else {
                m.classList.remove('active');
                document.body.style.overflow = '';
            }
        }
    }

    container.querySelectorAll('.ict-m-size-chart-trigger').forEach(btn => {
        btn.addEventListener('click', () => toggleModal('size-chart-modal-mobile', true));
    });

    // Move Zoom Modal to Body for proper Z-Index/Blur context
    const zoomModalEl = document.getElementById('zoom-modal-mobile');
    if (zoomModalEl && zoomModalEl.parentElement !== document.body) {
        document.body.appendChild(zoomModalEl);
    }

    // Listen for close on mobile modals
    const modalCloseElements = document.querySelectorAll('#size-chart-modal-mobile .ict-m-modal-close, #size-chart-modal-mobile .ict-m-modal-overlay, #zoom-modal-mobile .ict-m-modal-close, #zoom-modal-mobile .ict-m-modal-overlay');
    modalCloseElements.forEach(el => el.addEventListener('click', function () {
        const modal = this.closest('.ict-m-modal');
        if (modal) toggleModal(modal.id, false);
    }));


    // Zoom Logic & Thumbs
    const zoomTarget = document.getElementById('zoom-target-mobile');
    const thumbsContainer = zoomModalEl ? zoomModalEl.querySelector('.ict-m-zoom-thumbs') : null;
    let currentZoomIndex = 0;

    const getVisibleMedia = () => {
        return Array.from(container.querySelectorAll('.ict-m-media-wrapper')).filter(el => !el.classList.contains('ict-m-force-hide'));
    };

    const updateZoomUI = (visible) => {
        if (!zoomTarget || !visible.length) return;
        const currentEl = visible[currentZoomIndex];
        // Set Main Image
        zoomTarget.src = currentEl.dataset.zoomSrc || currentEl.querySelector('img').src;

        // Update Thumb Active State
        if (thumbsContainer) {
            const thumbs = thumbsContainer.querySelectorAll('.ict-m-zoom-thumb-item');
            thumbs.forEach((t, i) => {
                if (i === currentZoomIndex) t.classList.add('active');
                else t.classList.remove('active');
            });
            // Auto scroll thumbs
            const activeThumb = thumbs[currentZoomIndex];
            if (activeThumb) {
                activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
            }
        }
    };

    const renderThumbs = (visible) => {
        if (!thumbsContainer) return;
        thumbsContainer.innerHTML = '';
        visible.forEach((el, i) => {
            const imgEl = el.querySelector('img');
            const src = imgEl ? imgEl.src : '';
            const thumb = document.createElement('div');
            thumb.className = 'ict-m-zoom-thumb-item';
            thumb.innerHTML = `<img src="${src}">`;
            thumb.addEventListener('click', (e) => {
                e.stopPropagation();
                currentZoomIndex = i;
                updateZoomUI(visible);
            });
            thumbsContainer.appendChild(thumb);
        });
    };

    // Zoom Trigger Logic
    if (mediaCol) {
        mediaCol.addEventListener('click', function (e) {
            const trigger = e.target.closest('.ict-m-zoom-trigger');
            if (trigger) {
                const visible = getVisibleMedia();
                const idx = visible.indexOf(trigger);
                if (idx !== -1) {
                    currentZoomIndex = idx;
                    renderThumbs(visible); // Build thumbs
                    updateZoomUI(visible); // Set initial state
                    toggleModal('zoom-modal-mobile', true);
                }
            }
        });
    }

    // --- Navigation Logic (Clicks + Swipes) ---
    const goNext = () => {
        const visible = getVisibleMedia();
        if (!visible.length) return;
        currentZoomIndex = (currentZoomIndex + 1) % visible.length;
        // Optional: Add slide animation class here if desired
        updateZoomUI(visible);
    };

    const goPrev = () => {
        const visible = getVisibleMedia();
        if (!visible.length) return;
        currentZoomIndex = (currentZoomIndex - 1 + visible.length) % visible.length;
        updateZoomUI(visible);
    };

    const nextBtn = document.querySelector('#zoom-modal-mobile .ict-m-zoom-next');
    const prevBtn = document.querySelector('#zoom-modal-mobile .ict-m-zoom-prev');

    if (nextBtn) nextBtn.addEventListener('click', goNext);
    if (prevBtn) prevBtn.addEventListener('click', goPrev);

    // --- Swipe Detection ---
    const zoomContent = document.querySelector('#zoom-modal-mobile .ict-m-zoom-content');
    let touchStartX = 0;
    let touchEndX = 0;
    const swipeThreshold = 50; // Min distance to trigger

    if (zoomContent) {
        zoomContent.addEventListener('touchstart', (e) => {
            touchStartX = e.changedTouches[0].screenX;
        }, { passive: true });

        zoomContent.addEventListener('touchend', (e) => {
            touchEndX = e.changedTouches[0].screenX;
            handleSwipe();
        }, { passive: true });
    }

    const handleSwipe = () => {
        // Left Swipe (Next)
        if (touchEndX < touchStartX - swipeThreshold) {
            goNext();
        }
        // Right Swipe (Prev)
        if (touchEndX > touchStartX + swipeThreshold) {
            goPrev();
        }
    };

    // Tabs
    const tabs = container.querySelectorAll('.ict-m-tab-btn');
    const tabContents = container.querySelectorAll('.ict-m-tab-content');
    tabs.forEach(tab => {
        tab.addEventListener('click', function () {
            tabs.forEach(t => t.classList.remove('active'));
            tabContents.forEach(c => c.classList.remove('active'));
            this.classList.add('active');
            const targetId = `tab-${this.dataset.tab}-mobile`;
            const target = document.getElementById(targetId);
            if (target) target.classList.add('active');
        });
    });

    // Handle "Select Options" button click - scroll to variant selectors
    if (addBtn) {
        addBtn.addEventListener('click', function (e) {
            if (this.getAttribute('data-action') === 'select-options') {
                e.preventDefault();
                e.stopPropagation();

                // Find the first unselected option
                let targetElement = null;
                productOptions.forEach((_, idx) => {
                    if (state.options[idx] === null && !targetElement) {
                        const wrapper = container.querySelector(`[data-option-index="${idx}"]`);
                        if (wrapper) {
                            // Try to find a focusable element
                            const focusable = wrapper.querySelector('input:not([disabled]), select:not([disabled]), button:not([disabled])');
                            if (focusable) {
                                targetElement = focusable;
                            } else {
                                targetElement = wrapper;
                            }
                        }
                    }
                });

                // If no unselected option found, scroll to first option selector
                if (!targetElement) {
                    const firstWrapper = container.querySelector('[data-option-index]');
                    if (firstWrapper) {
                        const focusable = firstWrapper.querySelector('input:not([disabled]), select:not([disabled]), button:not([disabled])');
                        targetElement = focusable || firstWrapper;
                    }
                }

                if (targetElement) {
                    // Scroll to element with smooth behavior
                    targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });

                    // Focus the element if it's focusable
                    setTimeout(() => {
                        if (targetElement.focus) {
                            targetElement.focus();
                        }

                        // If it's a select, open it
                        if (targetElement.tagName === 'SELECT') {
                            targetElement.click();
                        }
                    }, 300);
                }

                return false;
            }
        });
    }

    // Run Init
    initInputs();

    // Clean Description (Remove embedded size guide headers)
    const cleanDescription = () => {
        const desc = container.querySelector('.ict-m-description-text');
        if (!desc) return;

        // Hide "Size Guide" Headers/Text
        const candidates = desc.querySelectorAll('h1, h2, h3, h4, h5, h6, p, strong, b, span, div');
        candidates.forEach(el => {
            const txt = el.textContent.trim().toLowerCase();
            // Strict match or starts with to avoid killing valid paragraphs
            if (txt === 'size guide' || txt === 'size chart' || txt === 'sizing') {
                el.style.display = 'none';
            }
        });
    };
    cleanDescription();

    // --- ACCORDION LOGIC ---
    const initAccordions = () => {
        const headers = container.querySelectorAll('.ict-m-accordion-header');

        headers.forEach(header => {
            header.addEventListener('click', function () {
                const item = this.parentElement;
                const panel = this.nextElementSibling;
                const isOpen = item.classList.contains('active');

                // Toggle Open/Close
                if (isOpen) {
                    // Close
                    item.classList.remove('active');
                    this.setAttribute('aria-expanded', 'false');
                    panel.style.maxHeight = null; // Clears it -> 0 from CSS triggers
                } else {
                    // Open
                    item.classList.add('active');
                    this.setAttribute('aria-expanded', 'true');
                    panel.style.maxHeight = panel.scrollHeight + "px";
                }
            });
        });
    };
    initAccordions();

});
